@if (dashboardHelper.panelEdgeToggleVisible | async) {
<button
  type="button"
  class="panel-edge-toggle"
  [attr.aria-label]="(dashboardHelper.isRightPanelExpanded | async) ? collapseTooltip : expandTooltip"
  [pTooltip]="(dashboardHelper.isRightPanelExpanded | async) ? collapseTooltip : expandTooltip"
  tooltipPosition="left"
  (click)="onToggle()">
  <i class="pi" [class.pi-chevron-right]="dashboardHelper.isRightPanelExpanded | async" [class.pi-chevron-left]="!(dashboardHelper.isRightPanelExpanded | async)"></i>
</button>
}
